import { navigateFocusDirective} from './keyNavigation';
import {navigateFocus, addKeyboardShortcut, removeKeyboardShortcut, getKeyboardShortcuts, handleKeyDown} from './keyboardShortcuts';


const registerDirectives = (app: any, newSyntax = false) => {
  const lifecycleName = newSyntax ? 'mounted' : 'inserted';

  app.directive('navigate-focus', {
    [lifecycleName]: navigateFocusDirective.mounted,
    unmounted: navigateFocusDirective.unmounted,
    unbind: navigateFocusDirective.unmounted // Vue 2 compatibility
  });

  app.directive('key-navigate', {
    [lifecycleName]: navigateFocusDirective.mounted,
    unmounted: navigateFocusDirective.unmounted,
    unbind: navigateFocusDirective.unmounted // Vue 2 compatibility
  });
}

const registerOnVue2 = (app ) => {
  Object.defineProperty(app.prototype, '$navigateFocus', {
    get() {
      return navigateFocus;
    }
  });

  Object.defineProperty(app.prototype, '$addKeyboardShortcut', {
    get() {
      return addKeyboardShortcut;
    }
  });

  Object.defineProperty(app.prototype, '$removeKeyboardShortcut', {
    get() {
      return removeKeyboardShortcut;
    }
  });

  Object.defineProperty(app.prototype, '$getKeyboardShortcuts', {
    get() {
      return getKeyboardShortcuts;
    }
  });

  window.addEventListener('keydown', handleKeyDown);

  registerDirectives(app, false);
}

// Vue 3 registration
const registerOnVue3 = (app) => {
  // Add global methods
  app.config.globalProperties.$navigateFocus = navigateFocus;
  app.config.globalProperties.$addKeyboardShortcut = addKeyboardShortcut;
  app.config.globalProperties.$removeKeyboardShortcut = removeKeyboardShortcut;
  app.config.globalProperties.$getKeyboardShortcuts = getKeyboardShortcuts;

  // Provide for composition API
  app.provide('navigateFocus', navigateFocus);
  app.provide('addKeyboardShortcut', addKeyboardShortcut);
  app.provide('removeKeyboardShortcut', removeKeyboardShortcut);
  app.provide('getKeyboardShortcuts', getKeyboardShortcuts);

  // Add global event listener for keyboard shortcuts
  window.addEventListener('keydown', handleKeyDown);

  // Register directives
  registerDirectives(app, true);
}

// Plugin installation
export const KeyNavigate = {
  install(app: any, _options = {}) {
    const isVue3 = !!app.config?.globalProperties;

    if (isVue3) {
      registerOnVue3(app);
    } else {
      registerOnVue2(app);
    }
  }
}

export {
  navigateFocus,
  addKeyboardShortcut,
  removeKeyboardShortcut,              
  getKeyboardShortcuts,
}